export const frtId = 40;

export const roadTransportId = 202;

export const superTransitId = 1;

export const authorizationCookie = 'access_token';

export const languageCookie = ".AspNetCore.Culture";